import React from 'react';
import {Redirect} from 'react-router-dom';

import {createRoutes} from '../../@crema/utility/Utils';
import {cargoPagesConfig} from '../cargo/pages';
import {cargoRouteConfig} from './panel';
import {errorPagesConfigs} from './errorPages';
import {authRouteConfig} from './auth';
import {initialUrl} from '../../shared/constants/AppConst';

const routeConfigs = [
  ...cargoRouteConfig,
  ...cargoPagesConfig,
  ...errorPagesConfigs,
  ...authRouteConfig,
];

const routes = [
  ...createRoutes(routeConfigs),
  {
    path: '/',
    exact: true,
    component: () => <Redirect to={initialUrl} />,
  },
];

export default routes;
